import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { AnalyticsListener } from '@atlaskit/analytics-next';
import { UI_EVENT_TYPE, OPERATIONAL_EVENT_TYPE, TRACK_EVENT_TYPE, SCREEN_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
export var FORGE_UI_ANALYTICS_CHANNEL = 'forge-ui';
export var sendEvent = function sendEvent(client) {
  return function (event) {
    switch (event.eventType) {
      case UI_EVENT_TYPE:
        Promise.resolve(client).then(function (c) {
          return c.sendUIEvent(event);
        });
        break;
      case OPERATIONAL_EVENT_TYPE:
        Promise.resolve(client).then(function (c) {
          return c.sendOperationalEvent(event);
        });
        break;
      case TRACK_EVENT_TYPE:
        Promise.resolve(client).then(function (c) {
          return c.sendTrackEvent(event);
        });
        break;
      case SCREEN_EVENT_TYPE:
        Promise.resolve(client).then(function (c) {
          return c.sendScreenEvent(event);
        });
        break;
    }
  };
};
/** extract the attributes from event context which should be in the top-level payload */
function getPayloadAttributesFromContext(contexts) {
  var _forgeUIAnalyticsCont, _contexts$find;
  return (_forgeUIAnalyticsCont = ((_contexts$find = contexts.find(function (obj) {
    return obj && obj.forgeUIAnalyticsContext;
  })) !== null && _contexts$find !== void 0 ? _contexts$find : {}).forgeUIAnalyticsContext) !== null && _forgeUIAnalyticsCont !== void 0 ? _forgeUIAnalyticsCont : {};
}
var ForgeUIAnalyticsListener = function ForgeUIAnalyticsListener(_ref) {
  var children = _ref.children,
    client = _ref.client,
    _ref$commonAttributes = _ref.commonAttributes,
    commonAttributes = _ref$commonAttributes === void 0 ? {} : _ref$commonAttributes;
  var listenerHandler = function listenerHandler(event) {
    var _ref2;
    var _event$payload = event.payload,
      eventType = _event$payload.eventType,
      data = _event$payload.data;
    var action = data.action,
      actionSubject = data.actionSubject,
      actionSubjectId = data.actionSubjectId,
      attributes = data.attributes,
      tags = data.tags,
      sourceFromEvent = data.source;
    var forgeUIAnalyticsContext = getPayloadAttributesFromContext(event.context);
    var source = (_ref2 = sourceFromEvent !== null && sourceFromEvent !== void 0 ? sourceFromEvent : forgeUIAnalyticsContext.source) !== null && _ref2 !== void 0 ? _ref2 : 'unknown';
    var payload = _objectSpread(_objectSpread({
      action: action,
      actionSubject: actionSubject,
      actionSubjectId: actionSubjectId
    }, forgeUIAnalyticsContext), {}, {
      source: source,
      attributes: _objectSpread(_objectSpread(_objectSpread({}, commonAttributes), event.context.reduce(function (prev, curr) {
        // Only extract attributes passed as an object via the forgeUIAttributes key
        var forgeUIAttributes = curr && curr.forgeUIAttributes && _typeof(curr.forgeUIAttributes) === 'object' ? curr.forgeUIAttributes : {};
        return _objectSpread(_objectSpread({}, prev), forgeUIAttributes);
      }, {})), attributes),
      tags: tags
    });
    sendEvent(client)(_objectSpread({
      eventType: eventType
    }, payload));
  };
  return /*#__PURE__*/React.createElement(AnalyticsListener, {
    onEvent: listenerHandler,
    channel: FORGE_UI_ANALYTICS_CHANNEL
  }, children);
};
export default ForgeUIAnalyticsListener;